import { logOut, logIn } from '@/helpers/oidcHelper';
import { createUserManager } from 'redux-oidc';

const identityUrl = process.env.ARKAS_APP_IDENTITY_URL;
const spaUrl = `${location.protocol}//${location.host}/`;

const userManagerConfig = {
  authority: identityUrl,
  client_id: 'EMutabakatWebClientId',
  redirect_uri: `${spaUrl}oidc/signin-callback`,
  post_logout_redirect_uri: `${identityUrl}identity/account/login`,
  silent_redirect_uri: `${spaUrl}oidc/silent-renew`,
  response_type: 'token id_token',
  scope: 'openid profile EMutabakatAPI custom_claims',
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true,

  // last 60 seconds
  accessTokenExpiringNotificationTime: 60
};

const userManager = createUserManager(userManagerConfig);

userManager.events.addUserSignedOut(function() {
  logOut();
});

userManager.events.addUserLoaded(function() {
  logIn();
});

export default userManager;
